import { render, staticRenderFns } from "./AXheader.vue?vue&type=template&id=1ff4d1ef&scoped=true&"
import script from "./AXheader.vue?vue&type=script&lang=js&"
export * from "./AXheader.vue?vue&type=script&lang=js&"
import style0 from "./AXheader.vue?vue&type=style&index=0&id=1ff4d1ef&lang=scss&scoped=true&"
import style1 from "./AXheader.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff4d1ef",
  null
  
)

export default component.exports